import { motion } from "framer-motion";

const chapters = [
  {
    n: "01",
    title: "The Belief",
    body: "A creative house built on one belief, that the best brands aren't just seen, they're felt.",
  },
  {
    n: "02",
    title: "The Practice",
    body: "15+ years of collective experience, and we still get unreasonably excited about a good brief.",
  },
  {
    n: "03",
    title: "The Range",
    body: "We work across social media, content, campaigns, production, music, and talent, because great marketing lives in the spaces between strategy and storytelling, between what a brand says and what it makes people feel.",
  },
];

export default function Manifesto() {
  return (
    <section
      id="manifesto"
      data-testid="manifesto-section"
      className="relative bg-[#0a0705] py-32 md:py-48"
    >
      <div className="mx-auto grid max-w-[1400px] grid-cols-12 gap-y-16 px-6 md:px-10">
        <div className="col-span-12 md:col-span-4">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            className="overline"
          >
            <span className="text-[#d99036]">§</span>&nbsp;&nbsp;About BHL
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
            className="mt-6 font-display text-5xl font-black leading-[0.95] tracking-tight md:text-6xl"
          >
            We are
            <br />
            <span className="font-serif-editorial italic font-normal text-[#d99036]">
              Butterhoney Labs.
            </span>
          </motion.h2>
        </div>

        <div className="col-span-12 md:col-span-7 md:col-start-6">
          <ol className="space-y-14 md:space-y-16">
            {chapters.map((c, i) => (
              <motion.li
                key={c.n}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{
                  duration: 0.9,
                  delay: i * 0.06,
                  ease: [0.22, 1, 0.36, 1],
                }}
                className="grid grid-cols-[auto_1fr] items-start gap-6 border-t border-[#2a1f17] pt-10 md:gap-10"
              >
                <span className="font-display text-lg font-bold text-[#d99036]">
                  {c.n}
                </span>
                <div>
                  <h3 className="overline mb-4 text-[#f9f6f0]">{c.title}</h3>
                  <p className="font-serif-editorial text-2xl leading-[1.35] text-[#f2ebdd] md:text-[28px]">
                    {c.body}
                  </p>
                </div>
              </motion.li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
